/* Deterministic avatar colors/initials (port of the design prototype's
   avColor/initials helpers in data.jsx). */
const AV_COLORS = [
  "#0e9f8e",
  "#2f9bd6",
  "#f4a024",
  "#7c5cff",
  "#e5635b",
  "#18a463",
  "#d4538e",
  "#5a6b9e",
];

export function avColor(s) {
  let h = 0;
  const str = s || "";
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = (h * 31 + str.charCodeAt(i)) >>> 0;
  }
  return AV_COLORS[h % AV_COLORS.length];
}

export function initials(name) {
  const p = (name || "").trim().split(/\s+/);
  return ((p[0]?.[0] || "") + (p[1]?.[0] || p[0]?.[1] || "")).toUpperCase() || "?";
}
